import { colors } from '@core/assistant/colors';

export const useStyles = () => {
  return {
    box: {
      width: 207,
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      background: colors.black_99,
      padding: 2,
      borderRadius: 6,
      border: `1px solid ${colors.white_90}`,
      backdropFilter: 'blur(60px)',
      position: 'relative',
      zIndex: 100,
    },
    button: {
      borderRadius: 99,
      border: '1px solid ' + colors.white,
      padding: 1.5,
      fontSize: 14,
      lineHeight: 1,
      textTransform: 'none',
      color: colors.white,
    },
    debugOverlay: {
      position: 'absolute',
      marginLeft: '-450px',
      width: '400px',
      background: 'rgba(10, 10, 10, 0.8)',
      height: '300px',
      padding: '10px',
      borderRadius: 6,

      button: {
        margin: '10px',
      },
    },
    debugButton: {
      borderRadius: '10px',
      border: '1px solid ' + colors.white,
      padding: 1.5,
      fontSize: 14,
      lineHeight: 1,
      textTransform: 'none',
      color: colors.white,
    },
    debugStartFlowButton: {
      position: 'relative',
      top: '6px',
    },
    debugSelect: {
      width: '180px',
      margin: '10px 20px 10px 10px',

      '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: colors.white,
      },
      '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: colors.white,
      },
      '& .MuiOutlinedInput-input': {
        color: colors.white,
      },
      '& .MuiSvgIcon-root': {
        color: colors.white,
      },
      '& .MuiInputLabel-root': {
        color: colors.white,
      },
      '& .MuiInputLabel-root.Mui-focused': {
        color: colors.myta,
      },
    },
    blueButton: {
      background: colors.myta,
    },
    nextButton: {
      padding: '8px 12px',
    },
    hideButton: {
      marginTop: 1,
      padding: 0,
      textTransform: 'none',
      fontSize: 14,
      lineHeight: 1.5,
      color: colors.white,
    },
    progressSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0.5,
    },
    progressBar: {
      borderRadius: 99,
      height: 6,
      backgroundColor: colors.grey_1,

      '& .MuiLinearProgress-bar': {
        backgroundColor: colors.myta,
        borderRadius: 99,
      },
    },
    progressLabels: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    progressText: {
      fontSize: 12,
      color: colors.white,
      lineHeight: 1,
      marginTop: 0.5,
      marginBottom: 1,
    },
    completedBox: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: 1.5,
      pb: 1,
    },
    completedIconCircle: {
      width: 56,
      height: 56,
      borderRadius: '50%',
      backgroundColor: '#eef6ee',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    completedTitle: {
      fontSize: 15,
      fontWeight: 700,
      color: colors.white,
      lineHeight: 1.3,
    },
    completedSubtitle: {
      fontSize: 13,
      color: colors.white,
      lineHeight: 1.4,
      mb: 1,
    },
  };
};
